<template>
  <v-row dense v-if="isActive && readingGlasses">
    <v-col>
      <v-row>
        <v-col class="text-h5 gray--text">
          Perto
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4">
          <v-row dense>
            <v-col class="text-subtitle-2 gray--text text--lighten-1">
              Esférico
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Olho direito
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ readingGlasses.sphericalRightEye }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Olho esquerdo
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ readingGlasses.sphericalLeftEye }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="4">
          <v-row dense>
            <v-col class="text-subtitle-2 gray--text text--lighten-1">
              Cilíndrico
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Olho direito
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ readingGlasses.cylindricalRightEye }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Olho esquerdo
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ readingGlasses.cylindricalLeftEye }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="4">
          <v-row dense>
            <v-col class="text-subtitle-2 gray--text text--lighten-1">
              Eixo
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Olho direito
                </v-col>
              </v-row>

              <v-row dense>
                <v-col> {{ readingGlasses.axisRightEye }}° </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Olho esquerdo
                </v-col>
              </v-row>

              <v-row dense>
                <v-col> {{ readingGlasses.axisLeftEye }}° </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-row dense>
            <v-col class="text-subtitle-2 gray--text text--lighten-1">
              Adição Dinâmica
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="auto">
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Adição Perto
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ readingGlasses.additionClose }}
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="auto">
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Adição intermediário
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ readingGlasses.additionIntermediary }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "GlassesPrescriptionReadingGlasses",
    props: {
      isActive: Boolean,
      readingGlasses: Object,
    },
  };
</script>

<style lang="scss" scoped></style>
